/**
 * Optional bridge to the Windows shell.
 *
 * The same bundle runs in a plain browser tab and inside the Electron shell.
 * In a tab there is no desktop, so every call degrades to a no-op and the
 * renderer never has to branch on its environment beyond this file.
 */

interface CalendarDesktop {
  config(): Promise<{ apiUrl: string; apiKey?: string }>;
  openExternal(url: string): Promise<void>;
  notify(title: string, body: string): void;
  setTrayIcon(dataUrl: string): void;
  onGoToday(callback: () => void): () => void;
  platform: string;
}

const desktop: CalendarDesktop | undefined = (
  (globalThis as { calendarDesktop?: CalendarDesktop }).calendarDesktop ?? undefined
);

export const isDesktop = desktop !== undefined;

/** OS-level notification with the system chime; a no-op in a browser tab. */
export function desktopNotify(title: string, body: string): void {
  desktop?.notify(title, body);
}

/** Live date badge for the tray; skipped when there is no tray. */
export function desktopSetTrayIcon(dataUrl: string): void {
  desktop?.setTrayIcon(dataUrl);
}

/** Subscribe to the tray's "Jump to today" action. Returns an unsubscribe. */
export function onDesktopGoToday(callback: () => void): () => void {
  return desktop?.onGoToday(callback) ?? (() => undefined);
}